import { Button, Modal } from "antd";
import parse from "html-react-parser";
import { inject, observer } from "mobx-react";
import queryString from "query-string";
import React from "react";
import FireRemoteService from "../../core/services/fire-remote";
import WalletService from "../../core/services/wallet";
import AppStore from "../../Store";
import QuestionPage from "../question/question";
import icon from "../../assets/images/error-modal-icon.png";

@inject("appStore")
@observer
export default class WalletFailPage extends React.Component<
{ appStore: AppStore, location: Location }> {

  public static url: string = "/wallet-fail";
  private walletService: WalletService = new WalletService();

  state = {
    isPaymentFailModalVisible: false,
    reason: ""
  }

  async componentDidMount() {
    const queryParams: any = queryString.parse(this.props.location.search);
    const transactionId: string = queryParams['transactionId'] ? queryParams['transactionId'] : queryParams['?transactionId'];
    const reason: string = queryParams["reason"];
    if (transactionId) {
      this.walletPaymentFail(transactionId, reason);
    }
  }

  walletPaymentFail = async (transactionId: string, reason: string) => {
    try {
      await this.walletService.walletPaymentFail(transactionId);
      this.setState({
        isPaymentFailModalVisible: true,
        reason
      });
    } catch (error) {
      this.props.appStore.handleUnknownErrorModalVisibility(true);
      console.error(error);
    }
  }

  handlePaymentFailButtonClick = () => {
    this.setState({
      isPaymentFailModalVisible: false
    });
    window.location.href = QuestionPage.url;
  }

  render() {
    return (
      <div id="wallet-fail">
        <Modal
          className="error-modal"
          visible={this.state.isPaymentFailModalVisible}
          onCancel={() => {
            this.setState({
              isPaymentFailModalVisible: false
            });
            window.location.href = QuestionPage.url;
          }}
          footer={false}
          closable={true}
          centered
          closeIcon={
            <img
              className="modal-icon-close"
              src="https://yaani.tcellcdn.net/kazankazan/icon-close.svg"
              alt="icon close"
            />
          }
        >
          <div id="error-modal-body">
            <img className="icon" src={icon} alt="error" />
            <p className="title">
              {parse(
                FireRemoteService.getStringValue(FireRemoteService.paymentFailMessageForCodeHeader + this.state.reason)
              )}
            </p>
            <p className="text">
              {parse(
                FireRemoteService.getStringValue(FireRemoteService.paymentFailMessageForCode + this.state.reason)
              )}
            </p>
            <Button
              onClick={this.handlePaymentFailButtonClick}
              className="modal-button primary">
              {parse(
                FireRemoteService.getStringValue(FireRemoteService.paymentErrorButton)
              )}
            </Button>
          </div>
        </Modal>
      </div>
    );
  }
}
